import { createFileRoute } from '@tanstack/react-router';
import { deletedSurveyCountQuery, surveysQuery } from '@/features/surveys/api';
import { SurveysPage } from '@/features/surveys/pages/SurveysPage';
import { surveysSearchSchema } from '@/features/surveys/search';

export const Route = createFileRoute('/_authed/ops/surveys/')({
  staticData: { help: 'surveys' },
  validateSearch: surveysSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, deps }) => {
    void queryClient.prefetchQuery(surveysQuery(deps));
    if (!deps.deleted) void queryClient.prefetchQuery(deletedSurveyCountQuery());
  },
  component: SurveysPage,
});
